import React from "react";
import { RotatingLines } from 'react-loader-spinner'



const DeleteLoader = ({ height = 80, width = 80 }) => (
   <div className="delete-loader">
      <RotatingLines
         strokeColor="red"
         strokeWidth="5"
         animationDuration="0.75"
         width="96"
         visible={true}
      />
   </div>
);

export default DeleteLoader;
